import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '@patternfly/react-styles/css/components/Tooltip/tooltip.mjs';
import { css } from '@patternfly/react-styles';
export const TooltipArrow = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return _jsx("div", Object.assign({ className: css(styles.tooltipArrow, className) }, props));
};
TooltipArrow.displayName = 'TooltipArrow';
//# sourceMappingURL=TooltipArrow.js.map